import { createContext, useContext } from "react";

/**
 * Lightweight bridge so callers outside `<SessionGuard>` (e.g. Apollo's
 * `onAuthFailure` wired in MemberProfilePage) can trigger the
 * session-expiry modal without prop-drilling.
 *
 * `<SessionGuard>` is the sole provider; consumers call
 * `useSessionEvents()` and invoke `triggerExpiryWarning(reason)`.
 */

export type ExpiryReason = "idle" | "auth-failure";

export interface SessionEvents {
  triggerExpiryWarning: (reason: ExpiryReason) => void;
}

// Default no-op: if a consumer renders outside <SessionGuard>, calls just
// drop on the floor. Avoids forcing every test / storybook to wrap with
// the guard.
const noop: SessionEvents = {
  triggerExpiryWarning: () => undefined,
};

export const SessionEventsContext = createContext<SessionEvents>(noop);

export function useSessionEvents(): SessionEvents {
  return useContext(SessionEventsContext);
}
